import "../validation/validation_helper.js"
import "../validation/additional-methods.js"

$(function () {

    const checkTaxUrl = $('meta[name="check-tax-id-url"]').attr('content');
    observeForm(
        "#rd-form",
        {
            ignore: [],
            rules: {
                UserName: {
                    taxId: true, required: true
                    , synchronousRemote: {
                        url: checkTaxUrl,
                        type: "post",
                        data: {
                            taxId: function () {
                                return $('input[name="UserName"]').val();
                            }
                        }
                    }
                },
                Password: {required: true, passwordStrength: true},
                CheckPassword: {
                    required: true,
                    passwordStrength: true,
                    equalTo: "input[name='Password']"
                },
                DistrictId: {required: true},
                CompanyAddress: {required: true},
                CompanyTitle: {required: true},
                CompanyTel: {required: true},
                IndustryCategoryId: {required: true},
                Name: {required: true},
                JobTitle: {required: true},
                Phone: {required: true},
                Email: {required: true, email: true},
                Agree: {required: true},
            },
            messages: {
                CheckPassword: {
                    equalTo: "密碼與確認密碼不一致"
                },
                UserName: {synchronousRemote: '統一編號已重複'},
                Agree: {required: '請同意服務條款與隱私政策'},
            }
        },
        confirmData,
    );

    $('select[name="cityId"]').on('change', function () {
        const cityId = $(this).val();
        const url = $('meta[name="get-district-url"]').attr('content');
        const token = $('meta[name="_csrf_token"]').attr('content');

        $.ajax({
            url: url,
            type: 'POST',
            headers: {
                'RequestVerificationToken': token
            },
            data: {cityId: cityId},
            success: function (data) {
                let districtSelect = $('select[name="DistrictId"]');
                districtSelect.empty();
                districtSelect.append($('<option>', {
                    value: '',
                    text: '請選擇'
                }));

                $.each(data, function (index, district) {
                    districtSelect.append($('<option>', {
                        value: district.Id,
                        text: district.Name
                    }));
                });
            },
            error: function (xhr, status, error) {
                console.error('取得區域資料失敗:', error);
                alert('無法載入區域資料，請重新整理頁面後再試');
            }
        });
    })
    
    $('#rd-reset-form').on('click', function () {
        $('#rd-form')[0].reset();
        $('#rd-form').find('.rd-notice').remove();
        $('#rd-form').find('input, select').css("border", "1px solid #ddd");
    })

    // 眼睛切換密碼顯示/隱藏功能
    $('.eye').on('click', function() {
        var $this = $(this);
        var $passwordInput = $this.closest('.pw-item').find('input');

        if ($this.hasClass('on')) {
            // 目前是顯示狀態，切換到隱藏
            $this.removeClass('on');
            $passwordInput.attr('type', 'text');
        } else {
            // 目前是隱藏狀態，切換到顯示
            $this.addClass('on');
            $passwordInput.attr('type', 'password');
        }
    });
})

function confirmData(form) {
    
    confirmDialog({
        message: "確定送出嗎？",
        btn_yes: "確定",
        btn_cancel: "取消",
        observer: function () {
            showLoadingDialog()
            const siteKey = $('meta[name="recaptcha-site-key"]').attr('content');
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, { action: 'login' }).then(function (token) {
                    $('#g-recaptcha-response').val(token);
                    showLoadingDialog()
                    setTimeout(function () {
                        form.submit();
                    }, 2000)
                });
            });
        },
    })
}